/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxLargeUploadSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_LARGE_UPLOAD_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxLargeUploadSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxLargeUploadSizeSettingParser.decode(input).map(res => new MaxLargeUploadSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxLargeUploadSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxLargeUploadSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxLargeUploadSizeSettingParser.schema();
    }
}
